import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";

import {
  CircularProgress,
  StepConnector,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Snackbar from "@mui/material/Snackbar";
import dayjs from "dayjs";
import UpsaleProduct from "../Component/UpsaleProductSalon";
import UserDetailsSection from "../Component/UserDetailSectionSalon";
import {
  setGuestFields,
  setTotalPrice,
  setTransactionDetails,
} from "../../store/slice/Salon.slice";
import {
  CreateSalonReservsation,
  transactionCostForReservationSalon,
} from "../../api/SalonService";
import { transactionCostForReservation } from "../../api/HorecaWidget.service";
import { format_Number } from "../../utils/utils";

dayjs?.extend(customParseFormat);
const DottedStepConnector = (props) => (
  <StepConnector
    {...props}
    sx={{
      "& .MuiStepConnector-line": {
        borderColor: "#000000",
        borderStyle: "dashed",
        borderWidth: 1,
      },
    }}
  />
);

export default function BooknowSalon() {
  const stepContentRef = React.useRef(null);
  const {
    guestDetails,
    upsaleProducts,
    upsaleProductPrice,
    totalPrice,
    selectedGenderType,
    selectedTreatmentType,
    selectedDate,
    selectedProffesionalDetails,
    selectedTime,
    selectedUpsaleProducts,
    guestFields,
    FieldsData,
    addFieldsData,
    languageWords,
    widgetSettings
  } = useSelector((store) => store.salon);

  const [steps, setSteps] = React.useState([
    languageWords?.Availability,
    languageWords?.ExtraProducts,
    languageWords?.yourDetails,
    languageWords?.ConfirmandPay,
  ]);
  const TOTALPRICE = totalPrice + upsaleProductPrice;
  const floating = "relative";
  const { defaultLanguage, key } = useSelector(
    (store) => store?.widgetSettings
  );
  const theme = useTheme();
  const { widgetConfig, deviceId,css } = useSelector(
    (store) => store?.widgetSettings
  );
  const Css = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Overall"
  )?.fields

  const { combinationQTY, selectedCombination } = useSelector(
    (store) => store?.Activity
  );
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(1);
  const [completed, setCompleted] = React.useState({ 0: false });
  const dispatch = useDispatch();
  const totalSteps = () => steps.length;
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const [createLoader, setCreateLoader] = React.useState(false);
  const { vertical, horizontal, open } = state;
  const handleClosebar = () => {
    setState({ ...state, open: true });

    setTimeout(() => {
      setState({ ...state, open: false });
    }, 5000);
  };
  const completedSteps = () => Object.keys(completed).length;
  const isLastStep = () => activeStep === totalSteps() - 1;
  const allStepsCompleted = () => completedSteps() === totalSteps();
  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const handleBack = () => {
    if (activeStep == 1) {
      navigate(-1);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNextFunc=(errors)=>{
    if (
      steps[activeStep] === languageWords?.yourDetails
    ) {
      if (Object.keys(errors).length == 0) {
        createReservation();
      }
    } else {
      handleNext();
    }
  }
  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };

  const updateWidgetHeight = () => {
    if (!stepContentRef.current) return;

    const contentHeight = Math.ceil(stepContentRef.current.scrollHeight);

    send(
      `${contentHeight}px`,
      "100%",
      "",
      "",
      "",
      "",
      widgetConfig?.settings?.floatButtonActive
    );
  };

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
      document.body.scrollTo({ top: 0, behavior: "smooth" });
  
      if (stepContentRef.current) {
        stepContentRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
      }
  
      updateWidgetHeight();
    }, 100);
  };
  
  React.useLayoutEffect(() => {
    updateWidgetHeight();
    scrollToTop();
  }, [activeStep, steps]);



  React.useEffect(() => {
    if (!stepContentRef.current) return;

    const observer = new ResizeObserver(() => {
      updateWidgetHeight();
    });

    observer.observe(stepContentRef.current);

    return () => observer.disconnect();
  }, []);
  const createInitialValuesAndValidationSchema = (guestData) => {
    const initialValues = {};
    const validationShape = {};

    const processFieldData = (
      field,
      languageType,
      customLink,
      shouldApplyValidation
    ) => {
      let languageData = field?.name;

      if (customLink) {
        languageData = "Link";
      } else if (field?.type == "textarea") {
        if (typeof field[languageType]?.[0]?.data === "string") {
          languageData = field[languageType]
            ?.find((f) => f?.fieldname == "name")
            ?.data?.replace(".", "");
        } else {
          languageData = field[languageType]?.find(
            (f) => f?.fieldname == "name"
          )?.data;
        }
      }

      if (!languageData) return;

      if (field?.type == "checkboxList") {
        initialValues[languageData] = [];
      } else {
        initialValues[languageData] = "";
      }

      let validationRule;
      if (field?.type === "label" || field?.type === "link") {
        validationRule = Yup.mixed().notRequired();
      } else if (field.tag === "{email}") {
        validationRule = Yup.string().email("Invalid email format");
      } else if (field.tag === "{phone}") {
        validationRule = Yup.string().matches(
          /^\+?\d{1,3}\s*\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
          "Invalid phone number format"
        );
      } else if (field?.type === "termsandcondition") {
        validationRule = Yup.boolean().oneOf(
          [true],
          "You must accept the terms and conditions"
        );
      } else if (field?.type == "checkboxList") {
        validationRule = Yup.array().of(Yup.string());
      } else {
        validationRule = Yup.string();
      }

      if (
        shouldApplyValidation &&
        field.required &&
        field?.type !== "label" &&
        field?.type !== "link"
      ) {
        validationRule = validationRule.required("Required");
      }
      validationShape[languageData] = validationRule;
    };

    guestData?.forEach((field) =>
      processFieldData(field, "guestLanguages", field.type == "link", true)
    );
    const AddprocessFieldData = (field, customLink, shouldApplyValidation) => {
      let languageData = field?.name;

      if (customLink) {
        languageData = "Link";
      } else if (field?.type == "textarea") {
        if (typeof field?.name === "string") {
          languageData = field?.name;
        } else {
          languageData = field?.name;
        }
      }

      if (!languageData) return;

      if (field?.type == "checkboxList") {
        initialValues[languageData] = [];
      } else {
        initialValues[languageData] = "";
      }

      let validationRule;

      if (field?.type === "label" || field?.type === "link") {
        validationRule = Yup.mixed().notRequired();
      } else if (field.type === "email") {
        validationRule = Yup.string().email("Invalid email format");
      } else if (field?.type === "phone") {
        validationRule = Yup.string().matches(
          /^\+?\d{1,3}\s*\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
          "Invalid phone number format"
        );
      } else if (field?.type === "termsandcondition") {
        validationRule = Yup.boolean().oneOf(
          [true],
          "You must accept the terms and conditions"
        );
      } else if (field?.type == "checkboxList") {
        validationRule = Yup.array().of(Yup.string());
      } else {
        validationRule = Yup.string();
      }

      if (
        shouldApplyValidation &&
        field.required &&
        field?.type !== "label" &&
        field?.type !== "link"
      ) {
        validationRule = validationRule.required("Required");
      }
      validationShape[languageData] = validationRule;
    };
    FieldsData?.forEach((field) =>
      AddprocessFieldData(field, field.type == "link", true)
    );
    return {
      initialValues,
      validationSchema: Yup.object().shape(validationShape),
    };
  };

  const { initialValues, validationSchema } =
    createInitialValuesAndValidationSchema(guestDetails);
  const createReservation = async () => {
    setCreateLoader(true);
    const idProffesional =
      typeof selectedProffesionalDetails == "string"
        ? selectedTime?.professionalIds[0]
        : selectedProffesionalDetails?.idSalonProfessional;
    const [arrivalTime, departureTime] = selectedTime?.timeRange?.split(" - ");
    const guestPayload = guestFields.reduce((acc, item) => {
      const key = item.idfield.replace(/[{}]/g, "");
      acc[key] = item.data;
      return acc;
    }, {});
    const payload = {
      key: key,
      paymentAmount: totalPrice + upsaleProductPrice,
      reservationUpsaleProduct: selectedUpsaleProducts,
      salonReservationFields: addFieldsData,
      gender: selectedGenderType?.idGender,
      WidgetId: Number(widgetSettings?.settings?.idwidgetsetup),
      idSalonTreatment: selectedTreatmentType?.idSalonTreatment,
      arrivalDate: dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
      arrivalTime: arrivalTime,
      departureTime: departureTime,
      price: selectedTreatmentType?.price,
      idSalonProfessional: idProffesional,
      language: defaultLanguage,
      guest: guestPayload,
      departureDate: dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
      isPaymentDone: true,
    };
    try {
      const response = await CreateSalonReservsation(payload);

      if (response?._links?.checkout?.href) {
        const checkoutUrl = response?._links?.checkout?.href;
        if (widgetConfig?.settings?.kioskMode || deviceId) {
          // Direct redirect
          window.location.href = checkoutUrl;
        } else {
          // Try postMessage
          if (window.parent && window.parent !== window) {
            window.parent.postMessage({ redirectUrl: checkoutUrl }, "*");
          } else {
            window.location.href = checkoutUrl;
          }
        }
      }
      setCreateLoader(false);
    } catch (error) {
      console.error("error:", error);
      setCreateLoader(false);
    }
  };

  const fetchTransactionDetails = async () => {
    try {
      const response = await transactionCostForReservationSalon(
        key,
        selectedTreatmentType?.idSalonTreatment,
        defaultLanguage
      );
      if (response?.status != 200 || !response?.data) {
        console.error("Transaction details not found");
      }
      dispatch(setTransactionDetails(response?.data));
    } catch (error) {
      console.error("error in transaction cost:", error?.message);
    }
  };

  React.useEffect(() => {
    fetchTransactionDetails();
  }, []);
  React.useEffect(() => {
    if (upsaleProducts?.length == 0) {
      setSteps([
        languageWords?.Availability,

        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [upsaleProducts]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {}}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          touched,
          errors,
          dirty,
          setFieldTouched,
          setFieldValue,
        }) => (
          <Box
            ref={stepContentRef}
            sx={{
              backgroundColor: theme?.widget?.stepScreenBgColor,            
              p: 1,
              position: "relative",
            }}
          >
            <Box
              sx={{
                backgroundColor: theme?.widget?.stepScreenBgColor,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  px: 2,
                  mb: 5,
                }}
              >
                <Stepper
                  nonLinear
                  activeStep={activeStep}
                  connector={<DottedStepConnector />}
                  sx={{
                    mt: 1,
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                    justifyContent: { xs: "center", sm: "flex-start" },
                  }}
                >
                  {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                      <StepButton
                      sx={{
                        ...(activeStep === index && {
                          "& .MuiStepLabel-label": {
                            color:
                              activeStep === index
                                ? Css?.SalonstepTextColorActive
                                : Css?.SalonstepTextColor,
                            fontWeight: "bold",
                            fontSize: "15px",
                          },
                          "& .MuiStepIcon-root": {
                            color:
                              activeStep === index
                                ? Css?.SalonstepCircleActiveBg
                                : Css?.SalonstepBtnDisabledBg,
                            borderRadius: "50%",
                            "& .MuiStepIcon-text": {
                              fill:
                                activeStep === index
                                  ? Css?.SalonstepCircleTextActive
                                  : Css?.SalonstepBtnText,
                            },
                          },
                        }),
                        width: { xs: "100%", sm: "auto" },
                        fontSize: { xs: "12px", sm: "inherit" },
                      }}
                        disabled={true}
                      >
                        {isSmallScreen ? "" : label}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </Box>
              <div>
                {allStepsCompleted() ? (
                  <React.Fragment>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Box>
                      {(() => {
                        switch (steps[activeStep]) {
                          case languageWords?.Availability:
                            navigate(-1, {
                              state: { openWidgetScreen: true },
                            });
                            break;

                          case languageWords?.ExtraProducts:
                            return <UpsaleProduct 
                            steps={steps}
                            activeStep={activeStep}
                            handleBack={handleBack}
                            handleNextFunc={handleNextFunc}
                            price={TOTALPRICE}
                            errors={errors}
                            isLoading={createLoader}
                            />;

                          case languageWords?.yourDetails:
                            return (
                              <UserDetailsSection
                              steps={steps}
                              touched={touched}
                            activeStep={activeStep}
                            handleBack={handleBack}
                            handleNextFunc={handleNextFunc}
                            price={TOTALPRICE}
                            errors={errors}
                            isLoading={createLoader}
                                defaultLanguage={defaultLanguage}
                                values={values}
                                setField={setFieldValue}
                               
                              
                                GuestDetailsData={guestDetails}
                                setGuestFields={setGuestFields}
                                FieldsData={FieldsData}
                              />
                            );

                          case languageWords?.ConfirmandPay:
                            return <></>;

                          default:
                            return <div>No page found</div>;
                        }
                      })()}
                    </Box>

               
                  </React.Fragment>
                )}
              </div>
            </Box>
          </Box>
        )}
      </Formik>
      <Box sx={{ width: 500 }}>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClosebar}
          message="Reservation creation Unsuccessful"
          key={vertical + horizontal}
        />
      </Box>
    </>
  );
}
